module.exports = __webpack_public_path__ + "assets/179a361722e9f74ebd7363b8264cfe16.png";